/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindOneQueryResponse, DocumentsControllerFindOnePathParams, DocumentsControllerFindOneQueryParams, DocumentsControllerFindOne400, DocumentsControllerFindOne401, DocumentsControllerFindOne403, DocumentsControllerFindOne404 } from "../../models/documentsController/DocumentsControllerFindOne";

function getDocumentsControllerFindOneUrl(id: DocumentsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}` as const }  
  return res
}

/**
 * @summary Get a document by ID
 * {@link /api/v1/documents/:id}
 */
export async function documentsControllerFindOne(id: DocumentsControllerFindOnePathParams["id"], params?: DocumentsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFindOneQueryResponse, ResponseErrorConfig<DocumentsControllerFindOne400 | DocumentsControllerFindOne401 | DocumentsControllerFindOne403 | DocumentsControllerFindOne404>, unknown>({ method : "GET", url : getDocumentsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}